'use client';

import { useContext } from 'react';
import { SessionContext } from 'next-auth/react';

/**
 * Состояние входа без требования провайдера.
 *
 * `useSession` из next-auth в разработке и тестах падает, если выше нет
 * `SessionProvider`. Верстак главной рисуется и под провайдером (витрина,
 * кабинет), и без него (серверные тесты разметки), поэтому здесь контекст
 * читается напрямую: без провайдера ответ `unknown`, и вызывающий ведёт
 * себя как раньше.
 *
 * Зачем верстаку вообще знать о входе (#213): список прошлых разговоров
 * отдаётся только вошедшему, и гостю запрос `/api/threads` возвращал 401.
 * Экран это переживал (история «недоступна без входа»), но ошибка
 * попадала в консоль, и PageSpeed снимал за неё балл «Рекомендаций».
 * Сессию провайдер всё равно спрашивает при загрузке, так что узнать
 * «гость» можно без второго запроса.
 */
export type SostoyanieVhoda = 'loading' | 'authenticated' | 'unauthenticated' | 'unknown';

export function useSostoyanieVhoda(): SostoyanieVhoda {
  const value = useContext(SessionContext);
  return value?.status ?? 'unknown';
}
